import React, { useState, useEffect } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import ImageSlider from './ImageSlider';
import DashboardCard from './DashboardCard';
import api from '../../services/api';
import '../../styles/Dashboard.css';

const Dashboard = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    fetchDashboardCards();
  }, []);

  const fetchDashboardCards = async () => {
    try {
      const response = await api.get('/dashboard/get_cards.php');
      if (response.data.success) {
        setCards(response.data.data);
      } else {
        setError('Failed to load dashboard cards');
      }
    } catch (err) {
      setError('Error fetching dashboard data');
      console.error('Dashboard error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (card) => {
    console.log('Card clicked:', card);
    alert(`Feature coming soon: ${card.title}`);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="dashboard-container">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <Header onToggleSidebar={toggleSidebar} />

        <main className="dashboard-main">
          <ImageSlider />

          <div className="dashboard-content">
            {/* Removed Dashboard Header Text */}
            
            {loading && <div className="loading">Loading dashboard...</div>}
            
            {error && <div className="error-message">{error}</div>}

            {!loading && !error && (
              <div className="cards-grid">
                {cards.map((card) => (
                  <DashboardCard 
                    key={card.id} 
                    card={card} 
                    onClick={handleCardClick}
                  />
                ))}
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
